module.exports = __webpack_public_path__ + "static/media/partizan-open-selling-logo.fac1c171.svg";